import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { filter, map, take } from 'rxjs/operators';
import {
  baseAssignmentsActions,
  baseAssignmentsSelectors,
  BaseAvatarSize,
  BaseButtonSize,
  BaseCoreState,
  BaseModalService,
  ProfileDocumentResponse,
  BaseFileExtension,
} from 'base';

@Component({
  selector: 'base-customer-candidate-document',
  templateUrl: './base-customer-candidate-document.component.html',
})
export class BaseCustomerCandidateDocumentComponent {
  @Input() document: ProfileDocumentResponse & { categoryLabel?: string };
  @Input() assignmentId: number;
  @ViewChild('documentViewerTemplate') documentViewerTemplate: ElementRef;

  avatarSize = BaseAvatarSize;
  buttonSize = BaseButtonSize;
  activeDocumentSrc: Blob;
  documentViewerModalRef: NgbModalRef;
  baseFileExtension = BaseFileExtension;

  constructor(private store: Store<BaseCoreState>, private modalService: BaseModalService) {}

  downloadDocument(openInModal = false): void {
    this.cleanDocumentViewer();

    if (this.assignmentId) {
      if (openInModal) {
        this.store
          .select(baseAssignmentsSelectors.getDocumentView)
          .pipe(
            filter((state) => !!state.data),
            map((state) => state.data),
            take(1)
          )
          .subscribe((document) => {
            this.openDocumentViewer(document as Blob);
          });
      }

      this.store.dispatch(
        baseAssignmentsActions.downloadCustomerCandidateDocument({
          payload: {
            assignment: this.assignmentId,
            document: this.document.id,
            documentType: this.document.type,
            openInModal,
          },
        })
      );
    }
  }

  private openDocumentViewer(document: Blob): void {
    this.activeDocumentSrc = document;
    this.documentViewerModalRef = this.modalService.open(
      {
        bodyTemplate: this.documentViewerTemplate,
        cancelButtonDisplayed: false,
        okButtonDisplayed: false,
        hideHeader: true,
        hideFooter: true,
      },
      { size: 'xl' }
    );
    this.documentViewerModalRef.result.then(
      () => this.cleanDocumentViewer(),
      () => this.cleanDocumentViewer()
    );
  }

  private cleanDocumentViewer() {
    this.store.dispatch(baseAssignmentsActions.clearDocumentView());
  }
}
